var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('confirm-action-dialog', {
    attrs: {
      "isDialogActive": _vm.dialogModel,
      "title": _vm.$t('views.fleet.FleetHomeVehicleTable.addVehicle'),
      "rightDisabled": _vm.currentStep === _vm.STEPS.ADD && (!_vm.isFormValid || !_vm.createVehicleDto.displayName),
      "leftText": _vm.$t('close'),
      "rightText": _vm.currentStep === _vm.STEPS.ADD ? _vm.$t('create') : _vm.$t('views.fleet.FleetHomeVehicleTable.anotherVehicle'),
      "loading": _vm.loading,
      "rightLoading": _vm.loading
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.dialogModel = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.dialogModel = $event;
      },
      "leftClick": _vm.close,
      "rightClick": _vm.rightClick,
      "close": _vm.close
    }
  }, [_c('v-stepper', {
    staticClass: "pa-0",
    attrs: {
      "flat": ""
    },
    model: {
      value: _vm.currentStep,
      callback: function callback($$v) {
        _vm.currentStep = $$v;
      },
      expression: "currentStep"
    }
  }, [_c('v-stepper-content', {
    key: _vm.STEPS.ADD,
    staticClass: "pa-0",
    attrs: {
      "step": _vm.STEPS.ADD
    }
  }, [_c('v-card-text', [_c('v-form', {
    model: {
      value: _vm.isFormValid,
      callback: function callback($$v) {
        _vm.isFormValid = $$v;
      },
      expression: "isFormValid"
    }
  }, [_c('div', {
    staticClass: "mt-1"
  }, [_vm._v(" " + _vm._s(_vm.$t("views.fleet.FleetVehicleListView.displayNameHint")) + " ")]), _c('v-text-field', {
    staticClass: "pt-1",
    attrs: {
      "label": _vm.$t('views.fleet.FleetVehicleListView.displayName'),
      "rules": _vm.requiredRule,
      "outlined": "",
      "required": "",
      "persistent-hint": ""
    },
    model: {
      value: _vm.createVehicleDto.displayName,
      callback: function callback($$v) {
        _vm.$set(_vm.createVehicleDto, "displayName", $$v);
      },
      expression: "createVehicleDto.displayName"
    }
  }), !_vm.isTrain ? _c('div', [_c('div', {
    staticClass: "mt-1"
  }, [_vm._v(_vm._s(_vm.$t("views.fleet.FleetVehicleListView.numberplateHint")))]), _c('numberplate-form', {
    key: _vm.uId,
    staticClass: "pt-2",
    attrs: {
      "countryCode": _vm.countryCode
    },
    model: {
      value: _vm.createVehicleDto.numberplate,
      callback: function callback($$v) {
        _vm.$set(_vm.createVehicleDto, "numberplate", $$v);
      },
      expression: "createVehicleDto.numberplate"
    }
  }), _vm.debug ? _c('v-text-field', {
    attrs: {
      "label": _vm.$t('views.fleet.FleetVehicleListView.numberplate'),
      "outlined": "",
      "persistent-hint": ""
    },
    model: {
      value: _vm.createVehicleDto.numberplate,
      callback: function callback($$v) {
        _vm.$set(_vm.createVehicleDto, "numberplate", $$v);
      },
      expression: "createVehicleDto.numberplate"
    }
  }) : _vm._e(), _c('div', {
    staticClass: "mt-1"
  }, [_vm._v(_vm._s(_vm.$t("views.fleet.FleetVehicleListView.identificationnumberHint")))]), _c('v-text-field', {
    staticClass: "pt-1",
    attrs: {
      "label": _vm.$t('views.fleet.FleetVehicleListView.identificationnumber'),
      "rules": _vm.vinRuleLength,
      "outlined": "",
      "persistent-hint": "",
      "suffix": _vm.getChecksumText,
      "counter": "17",
      "clearable": ""
    },
    model: {
      value: _vm.createVehicleDto.identificationnumber,
      callback: function callback($$v) {
        _vm.$set(_vm.createVehicleDto, "identificationnumber", $$v);
      },
      expression: "createVehicleDto.identificationnumber"
    }
  }), _c('Can', {
    attrs: {
      "I": _vm.ActionEnum.READ,
      "a": _vm.ResourceEnum.FLEET,
      "field": _vm.partnerId
    }
  }, [_c('v-autocomplete', {
    staticClass: "pt-1",
    attrs: {
      "items": _vm.filteredFleets,
      "loading": _vm.isSearchingFleets,
      "search-input": _vm.fleetSearchPattern,
      "label": _vm.$t('views.fleet.FleetVehicleListView.groupId'),
      "placeholder": _vm.$t('components.partner.CreateVehicleDialog.searchForFleet'),
      "color": _vm.groupId ? 'success' : '',
      "outlined": "",
      "persistent-hint": "",
      "clearable": "",
      "item-value": "id",
      "hint": _vm.$t('components.partner.CreateVehicleDialog.fleetSearchHint'),
      "no-filter": true
    },
    on: {
      "update:searchInput": function updateSearchInput($event) {
        _vm.fleetSearchPattern = $event;
      },
      "update:search-input": [function ($event) {
        _vm.fleetSearchPattern = $event;
      }, _vm.debounceFleetSearch]
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(item.title))])], 1)];
      }
    }, {
      key: "selection",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_vm.groupId ? _c('v-icon', {
          staticClass: "mr-2",
          attrs: {
            "small": "",
            "color": "success"
          }
        }, [_vm._v("mdi-check-circle")]) : _vm._e(), _vm._v(" " + _vm._s(item.title) + " ")];
      }
    }, {
      key: "no-data",
      fn: function fn() {
        return [_vm.isSearchingFleets ? _c('v-list-item', [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(" " + _vm._s(_vm.$t("components.partner.CreateVehicleDialog.searchingFleets")) + " ")])], 1)], 1) : _c('v-list-item', [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(" " + _vm._s(_vm.fleetSearchPattern && _vm.fleetSearchPattern.length >= 2 ? _vm.$t("components.partner.CreateVehicleDialog.noFleetsFound") : _vm.$t("components.partner.CreateVehicleDialog.searchForFleet")) + " ")])], 1)], 1)];
      },
      proxy: true
    }], null, false, 2071815161),
    model: {
      value: _vm.groupId,
      callback: function callback($$v) {
        _vm.groupId = $$v;
      },
      expression: "groupId"
    }
  })], 1)], 1) : _vm._e()], 1)], 1), _c('debug', {
    attrs: {
      "debug": _vm.createVehicleDto
    }
  }), _c('debug', [_vm._v("GroupID: " + _vm._s(_vm.groupId))])], 1), _c('v-stepper-content', {
    key: _vm.STEPS.SUCCESS,
    attrs: {
      "step": _vm.STEPS.SUCCESS
    }
  }, _vm._l(_vm.created, function (vehicle) {
    return _c('refs-vehicle', {
      key: vehicle.id,
      attrs: {
        "item": vehicle
      },
      on: {
        "openDetail": function openDetail($event) {
          return _vm.goToVehicleDetail(vehicle);
        }
      }
    });
  }), 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }